const URL_FILTER = {
  'FULL_URL': 'FULL_URL',
  'URL_WITHOUT_PROTOCOL': 'URL_WITHOUT_PROTOCOL',
  'PATH_ONLY': 'PATH_ONLY',
  'DOMAIN_ONLY': 'DOMAIN_ONLY'
};

export default URL_FILTER;
